import { ModeuleNotAvailable } from "components/ui/shared/ModuleNotAvailable"
import styled from "styled-components"

export const ResSlope = () => {
    return (
        <StyledResSlope>
            <ModeuleNotAvailable/>
        </StyledResSlope>
    )
}

const StyledResSlope = styled.div`
    flex: 1;
    width: 100%;
`